import React, { useState, useEffect, useContext } from "react";
import { Navigate } from 'react-router-dom';
import axios from "axios";
import moment from "moment";
import DataTable from "react-data-table-component";
import { makeStyles } from "@mui/styles";
import LinearProgress from "@mui/material/LinearProgress";
import Tooltip from "@mui/material/Tooltip";
import VisibilityIcon from "@mui/icons-material/Visibility";
import CheckIcon from "@mui/icons-material/Check";
import EditIcon from "@mui/icons-material/Edit";
import {
  NotificationContainer,
  NotificationManager,
} from "react-notifications";
import styles from "assets/jss/material-dashboard-pro-react/views/extendedTablesStyle.js";

import UserService from "services/UserService";
import { getActionPlan, deleteAction } from "services/ConfigServices";
import { ActionContext } from "context/ActionContext";
import { IntInput } from "components/Input/Index.js";
import Button from "components/CustomButtons/Button.js";
import useActionTable from "./useActionTable.js";
import {targetedenergyList} from "variables/lists/action";

const useStyles = makeStyles(styles);
//import "react-table/react-table.css";

// @mui/icons-material

const RTExpertSavings = () => {
  const permis = JSON.parse(localStorage.getItem("permission")) || [];
  const actionplanupdate = permis.includes("actionplan_update");
  const { gridState } = useActionTable();
  const appContext = useContext(ActionContext);
  const { action, setAction } = appContext;
  const [editableRowId, setEditableRowId] = useState(false);

  const [newData, setNewData] = useState([]);

  const classes = useStyles();

  useEffect(() => {
    setNewData(gridState.data);
  }, [gridState.data]);

  const columns = [
    {
      name: "Fluide",
      selector: (row) => action?.parameters?.perimeter?.energy,
      sortable: true,
      cell: (row) => 
      targetedenergyList.find(obj=>obj.id===action?.parameters?.perimeter?.energy)?.name || "",
    },
    {
      name: "Economies (MWh)",
      selector: (row) => row.savingskwh,
      sortable: true,
      cell: (row) => row.savingskwh ? new Intl.NumberFormat('fr-FR',{maximumFractionDigits : 2}).format(row.savingskwh/1000) : ''
    },
    {
      name: "Economies (€)",
      selector: (row) => row.savingseuro,
      sortable: true,
    },
    {
      name: "Economies (kg eq. CO2)",
      selector: (row) => row.savingsco2,
      sortable: true,
    },
  ];

  function indexFinder(rowId) {
    const indexOfId = newData.findIndex((obj) => obj.energy == rowId);

    return indexOfId;
  }

  const handleChange = (e, id) => {
    const { name, value } = e.target;
    const indexOfId = newData.findIndex((obj) => obj.energy == id);

    let newArray = [...newData];
    newArray[indexOfId][name] = value;

    setNewData(newArray);
  };

  const editEnabled = (row) => async () => {
    editableRowId === row.energy
      ? setEditableRowId(null)
      : setEditableRowId(row.energy);
  };

  const contextMessage = {
    singular: "enr",
    plural: "enr",
    message: "sélectionné(s)",
  };

  return (
    <>
      <DataTable
          paginationRowsPerPageOptions={[10,20,30,50,100]}
        noHeader={true}
        //title="Simulation"
        subHeader
        noDataComponent="Aucune simulation trouvée"
        columns={columns}
        persistTableHead
        progressPending={gridState.loading}
        progressComponent={<LinearProgress />}
        highlightOnHover
        {...gridState}
        contextMessage={contextMessage}
      />
    </>
  );
};

export default RTExpertSavings;
